// UZB
export const API = "https://gapuz.pro/api";
export const alPechka = "6778db412d059c7c8f433039";
export const alPechkaMachine = "677c1ed31a3ebbe7ee98bf5b";
export const lom = "6778d8872d059c7c8f432fd5";
export const sim = "6778d8a82d059c7c8f432fd9";

// KHUJAND
// export const API = "https://khujand.gapuz.pro/api";
// export const alPechka = "67d9342e52876c5a8a7ac83d";
// export const alPechkaMachine = "67d9349a52876c5a8a7ac86d";
// export const lom = "67d7f5bc10775eb2128ae296";
// export const sim = "67d7f5f010775eb2128ae29e";

// KHAVATAG
// export const API = "https://khavatag.gapuz.pro/api";
// export const alPechka = "67d9342e52876c5a8a7ac83d";
// export const alPechkaMachine = "67d9349a52876c5a8a7ac86d";
// export const lom = "67d7f5bc10775eb2128ae296";
// export const sim = "67d7f5f010775eb2128ae29e";
